import $ from 'jquery';
import { ifError } from 'assert';

export default () => {
  let isBackend = ($('body[data-backend]').length > 0);
  let isRtl = $("html").attr("dir") === "rtl";

  if ($('.contact-form__body').length == 0 && isBackend) {
    $('.contact-form').css('margin-top', '0');
  }

  if (!isBackend) {
    $('.contact-form').css('background-image', "url('/images/contact-us/background.png')");

    if (isRtl) {
      $('.contact-form').css('background-image', "url('/images/contact-us/background-ar.png')");
    }
  }

  $(document).ready(function () {
    if ($('.contact-form__textarea').length) {
      textAreaIncrease();
    }

    contactValidation();
  });


  let textAreaIncrease = () => {
    var textarea = document.querySelector(".contact-form__textarea");
    var limit = 140;

    textarea.oninput = function () {
      textarea.style.height = "";
      textarea.style.height = Math.min(textarea.scrollHeight, limit) + "px";
    };
  }
  let contactValidation = () => {
    var $self = this;
    const form = document.querySelector(".contact-form__body");

    if (form === null) {
      return;
    }

    let isRtl = $("html").attr("dir") === "rtl";
    if (isRtl) {
      let mapUrl = $('[data-map-ar-url]').attr('[data-map-ar-url]');
      $('.contact-form-map-link').attr('href', mapUrl);
    }

    $('.contact-form__button-send').on('click', function (e) {
      const inputErrors = [...document.querySelectorAll(".contact-form__input-error")];

      inputErrors.forEach(inputErrors => {
        inputErrors.innerHTML = "";
      });

      const inputField = [...form.querySelectorAll('.contact-form__input')];
      const inputTextArea = [...form.querySelectorAll('.contact-form__textarea')];
      let errors = false;

      inputField.forEach(input => {
        let $inputEl = $(input);
        let required = $inputEl.attr('data-required');
        let regExp = $inputEl.attr('data-regExp');
        let errorMessage = $inputEl.attr('data-error-message');
        let inputValue = input.value;
        errorMessage = "<i class='fas fa-exclamation-triangle'></i> " + errorMessage;

        input.classList.remove("error")

        const InputFieldNameRegex = (/^[a-zA-Z]([-']?[a-z]+)*( [a-zA-Z]([-']?[a-z]+)*)+$/);
        const inputFieldMailRegex = (/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

        if (required == 'true') {
          if (input.type == 'email') {
            if (!inputFieldMailRegex.test(inputValue)) {
              errors = true;
              outputInputError(input, errorMessage);
            }
          } else if (input.type == 'text') {
            if (regExp && !new RegExp(regExp).test(inputValue)) {
              errors = true;
              outputInputError(input, errorMessage);
            } else if (!regExp) {
              if (input.value.length < 1) {
                errors = true;
                outputInputError(input, errorMessage);
              }
            }
          }
        }
        $inputEl.change(() => { 
          $inputEl.closest('form').find('.contact-form__button-send').removeAttr('disabled');
        });
      });

      inputTextArea.forEach(input => {
        let $inputEl = $(input);
        let required = $inputEl.attr('data-required');
        let errorMessage = $inputEl.attr('data-error-message');

        const textAreaErrorMessage = "<i class='fas fa-exclamation-triangle'></i> " + errorMessage;

        let inputValue = input.value;

        input.classList.remove("error");

        if (required == 'true') {
          if (inputValue.length == 0 || inputValue.value == '') {
            errors = true;
            outputInputError(input, textAreaErrorMessage);
          }
        }
        $inputEl.change(() => { 
          $inputEl.closest('form').find('.contact-form__button-send').removeAttr('disabled');
        });
      });

      if (errors) {
        $('.contact-form__body').addClass('contact-form-errors');
      }
      else {
        $('.contact-form__body').removeClass('contact-form-errors');

      }
    });

  };

  let outputInputError = (input, error) => {
    const inputParent = input.parentNode;
    const inputErrorElement = inputParent.querySelector(".contact-form__input-error");
    inputErrorElement.innerHTML = error;
    input.classList.add("error");
  };
};
